import * as yup from 'yup'
import { CompanyDto } from './companyDto'
import { CompanyAddressDto } from './companyAddressDto'
import { TitleProcessingStateDto } from './titleProcessingStateDto'

export class VehicleExporterInformationDto {
  exporterMileage?: number = undefined
  exporterMileageUnitOfMeasurement?: string = undefined
  buyerCompany?: CompanyDto = undefined
  titleProcessingState?: TitleProcessingStateDto = undefined
  titleDestinationCompany?: CompanyDto = undefined
  titleDestinationCompanyAddress?: CompanyAddressDto = undefined
  vehicleDestinationCompany?: CompanyDto = undefined
  vehicleDestinationCompanyAddress?: CompanyAddressDto = undefined
  exporterConvertCluster?: boolean = undefined
  isPreviousUSVehicleBox2A?: boolean = undefined
}

export const vehicleExporterInformationValidationSchema = yup.object({
  exporterMileage: yup.number().required('Exporter Mileage is required.'),
  exporterMileageUnitOfMeasurement: yup
    .string()
    .oneOf(['Miles', 'Kilometers'], 'Units of Distance must be Miles or Kilometers.')
    .required('Units of Distance is required.'),
  buyerCompany: yup.object().nullable(),
  titleProcessingState: yup.object().required('Title Processing State is required.'),
  titleDestinationCompany: yup.object().required('Title Destination Company is required.'),
  titleDestinationCompanyAddress: yup.object().required('Title Destination Company Address is required.'),
  vehicleDestinationCompany: yup.object().required('Vehicle Destination Company is required.'),
  vehicleDestinationCompanyAddress: yup.object().required('Vehicle Destination Company Address is required.'),
  exporterConvertCluster: yup.bool().required('Convert Cluster is required.')
})
